import { ApiService } from 'js/src/client';
import { getQueryParam } from 'js/src/libs/querystring';

export async function attachVideoToApiRequest(videoId: number | string): Promise<void> {
    const requestId = getQueryParam('video_creation_request');
    if (!requestId) return;
    try {
        await ApiService.v1VideoCreationRequestsAttachVideoCreate({
            path: { request_id: requestId },
            body: { video_id: Number(videoId) },
        });
    } catch {
        // Non-fatal — the user's save succeeded; attach is bookkeeping.
    }
}
